import { ActionType, getType } from 'typesafe-actions'
import { IDuplicateOrderCheck } from '../../../api'

import { IFetchedResource } from '../../types'

import * as actions from './actions'

interface IState extends IFetchedResource<IDuplicateOrderCheck, Error> {}

const initialState: IState = {
  isFetching: false,
}

export const reducer = (
  state: IState = initialState,
  action: ActionType<typeof actions>,
): IState => {
  switch (action.type) {
    case getType(actions.FETCH_DUPLICATE_ORDER_CHECK.request): {
      return {
        isFetching: true,
      }
    }

    case getType(actions.FETCH_DUPLICATE_ORDER_CHECK.failure): {
      return {
        isFetching: false,
        error: action.payload,
      }
    }

    case getType(actions.FETCH_DUPLICATE_ORDER_CHECK.success): {
      return {
        ...state,
        item: action.payload,
        isFetching: false,
      }
    }

    case getType(actions.FETCH_DUPLICATE_ORDER_CHECK.cancel): {
      return {
        isFetching: false,
      }
    }
  }

  return state
}
